import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Notifications = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 18C24.45 18 24 17.55 24 17V12C24 7.588 20.413 4 16 4C11.587 4 8 7.588 8 12V17C8 17.55 7.55 18 7 18C5.35 18 4 19.35 4 21C4 22.65 5.35 24 7 24H12C12 26.2 13.8 28 16 28C18.2 28 20 26.2 20 24H25C26.65 24 28 22.65 28 21C28 19.35 26.65 18 25 18ZM16 26C14.9 26 14 25.1 14 24H18C18 25.1 17.1 26 16 26ZM25 22H7C6.45 22 6 21.55 6 21C6 20.45 6.45 20 7 20C8.65 20 10 18.65 10 17V12C10 8.687 12.688 6 16 6C19.312 6 22 8.688 22 12V17C22 18.65 23.35 20 25 20C25.55 20 26 20.45 26 21C26 21.55 25.55 22 25 22Z" />
	</svg>
);

export default Notifications;
